import { get } from 'lodash'

export default function(data) {
  const activity = {}

  if (data) {
    activity.aim = get(data, 'aim')
    activity.assessorEmail = get(data, 'assessorEmail')
    activity.assessorTitle = get(data, 'assessorTitle')
    activity.assessorName = get(data, 'assessorName')
    activity.assessorPhone = get(data, 'assessorPhone')
  }

  return activity
}
